import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchCatHome, boxsetsFetchData } from '../actions';
import CardRow from './CardRow';
import CardGrid from './CardGrid';
import translate from './TranslateHOC';
import {
  CMS_PROGROW_TYPE_CATEGORY,
  CMS_PROGROW_TYPE_BOXSET,
  CAT_ROW_LIMIT,
} from '../constants';

class HomeCategories extends Component {
  componentDidMount = () => {
    if (this.props.programmeRow.type === CMS_PROGROW_TYPE_CATEGORY) {
      this.props.fetchCatHome(this.props.programmeRow.categoryId);
    }
    if (this.props.programmeRow.type === CMS_PROGROW_TYPE_BOXSET) {
      this.props.fetchBoxsets();
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    if (nextProps.curLang !== this.props.curLang) {
      if (nextProps.programmeRow.type === CMS_PROGROW_TYPE_CATEGORY) {
        this.props.fetchCatHome(nextProps.programmeRow.categoryId);
      }
      if (nextProps.programmeRow.type === CMS_PROGROW_TYPE_BOXSET) {
        this.props.fetchBoxsets();
      }
    }
  };

  getProgrammes = (arrayProg, catId) => {
    let progItems = [];
    for (let i = 0; i < arrayProg.length; i++) {
      if (String(Object.keys(arrayProg[i])) === String(catId)) {
        progItems = arrayProg[i][catId];
        break;
      }
    }
    return progItems;
  };

  render() {
    const {
      index,
      programmeRow,
      homeLoading,
      homeError,
      catProgrammes,
      catProgIsLoading,
      catProgHasErrored,
      boxsets,
      boxsetsIsLoading,
      boxsetsHasErrored,
      forceCardGrid,
      signed,
    } = this.props;
    let dataLoading = homeLoading,
      dataError = homeError,
      items = programmeRow.cards;
    let { itemsLimit } = this.props;

    if (itemsLimit === undefined) {
      itemsLimit =
        programmeRow.type === CMS_PROGROW_TYPE_BOXSET ? 99 : CAT_ROW_LIMIT;
    }

    if (programmeRow.type === CMS_PROGROW_TYPE_CATEGORY) {
      if (homeLoading || catProgIsLoading) {
        dataLoading = true;
      }
      if (homeError || catProgHasErrored) {
        dataError = true;
      }
      items = this.getProgrammes(
        catProgrammes,
        this.props.programmeRow.categoryId
      );
    }

    if (programmeRow.type === CMS_PROGROW_TYPE_BOXSET) {
      if (homeLoading || boxsetsIsLoading) {
        dataLoading = true;
      }
      if (homeError || boxsetsHasErrored) {
        dataError = true;
      }
      items = boxsets.cards;
    }

    const useCardGrid = forceCardGrid ? true : false;

    return (
      <>
        {items && items.length > 0 && useCardGrid && (
          <CardGrid
            key={index}
            items={items}
            itemsIsLoading={dataLoading}
            itemsHasErrored={dataError}
            itemsLimit={!forceCardGrid ? itemsLimit : 99}
            billingBool={true}
            countBool={
              programmeRow.type === CMS_PROGROW_TYPE_BOXSET ? true : false
            }
            posterCards={
              programmeRow.type === CMS_PROGROW_TYPE_BOXSET ? true : false
            }
            signed={signed}
          />
        )}
        {items && items.length > 0 && !useCardGrid && (
          <CardRow
            key={index}
            items={items}
            itemsIsLoading={dataLoading}
            itemsHasErrored={dataError}
            itemsLimit={itemsLimit}
            billingBool={true}
            countBool={
              programmeRow.type === CMS_PROGROW_TYPE_BOXSET ? true : false
            }
            posterCards={
              programmeRow.type === CMS_PROGROW_TYPE_BOXSET ? true : false
            }
            signed={signed}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    curLang: state.curLang,
    auth: state.auth.authenticated,
    catProgrammes: state.fetchHomeCategories,
    catProgIsLoading: state.fetchHomeCategoriesIsLoading,
    catProgHasErrored: state.fetchHomeCategoriesHasErrored,
    boxsets: state.boxsets.success,
    boxsetsIsLoading: state.boxsets.loading,
    boxsetsHasErrored: state.boxsets.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCatHome: (id) => dispatch(fetchCatHome(id)),
    fetchBoxsets: () => dispatch(boxsetsFetchData()),
  };
};

export default translate(
  connect(mapStateToProps, mapDispatchToProps)(HomeCategories)
);
